import React, { useEffect, useState } from "react";
import HRNavbar from "../../HR/HRNavbar";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { TextField, Button, TablePagination } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import InputBase from "@mui/material/InputBase";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import CardContent from "@mui/material/CardContent";
import { styled } from "@mui/system";
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import TableCell from "@mui/material/TableCell";
import Footer from "../../../Footer";
import { API_URL } from "../../Config/api";

const HospitalCard = styled(Card)({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
  marginTop: "10px",
  marginRight: "10px",
  backgroundColor: "white",
  boxShadow: "4px 4px 10px 7px rgba(135, 135, 135, 0.05)",
  height: "43px",
  borderRadius: "10px",
  transition: "0.5s ease-in-out",
  "&:hover": {
    backgroundColor: "#F7F7F7",
    cursor: "pointer",
  },
  fontWeight: "200",
});

const HospitalReport = () => {
  const [hospitalType, setHospitalType] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [hospDataTable, setHospDataTable] = useState([]);
  const accessToken = localStorage.getItem("token");
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [hospitalData, setHospitalData] = useState([]);
  console.log("hspdata", hospitalData);


 const [isSmallScreen, setIsSmallScreen] = useState(false); // Moc
  
    useEffect(() => {
      // Set screen size state dynamically
      const handleResize = () => setIsSmallScreen(window.innerWidth < 600);
      window.addEventListener("resize", handleResize);
      handleResize(); // Initial call
      return () => window.removeEventListener("resize", handleResize);
    }, []);

  // const port = process.env.REACT_APP_API_KEY;

  const handleViewReport = async () => {
    setLoading(true);
    try {
      let url = `${API_URL}/hhc_repo/hospital_patient_count_Report/?`;

      if (startDate) {
        url += `fromdate=${startDate}&`;
      }
      if (endDate) {
        url += `todate=${endDate}&`;
      }
      if (hospitalType) {
        url += `hospital_name=${hospitalType}&`;
      }

      const res = await fetch(url.slice(0, -1), {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      });

      console.log(res);
      const data = await res.json();
      setHospDataTable(data);
      setLoading(false);
      console.log("Consultant Data", data);
    } catch (error) {
      console.error("Error fetching Consultant Report Data:", error);
      setLoading(false);
    }
  };

  const handleDownloadExcel = async () => {
    try {
      let url = `${API_URL}/hhc_repo/hospital_patient_count_Report/?`;

      if (startDate) {
        url += `fromdate=${startDate}&`;
      }
      if (endDate) {
        url += `todate=${endDate}&`;
      }
      if (hospitalType) {
        url += `hospital_name=${hospitalType}&`;
      }

      const res = await fetch(url.slice(0, -1), {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      });
      const data = await res.json();

      const renamedData = data.map((item) => ({
        "Hospital Name": item.hospital_name,
        "Patient Count": item.patient_count,
      }));

      const worksheet = XLSX.utils.json_to_sheet(renamedData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Hospital Report");
      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      saveAs(
        new Blob([excelBuffer], { type: "application/octet-stream" }),
        "hospital_report.xlsx"
      );
    } catch (error) {
      console.error("Error fetching Enquiries Data:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    const hospitalData = async () => {
      try {
        const res = await fetch(`${API_URL}/web/agg_hhc_hospitals_api`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        });
        console.log(res);
        const data = await res.json();
        setHospitalData(data);
        console.log("Data from hospitalData", data);
      } catch (error) {
        console.error("Error fetching hospitalData Data:", error);
      }
    };
    hospitalData();
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  /////// date changes validation
  const handleStartDateChange = (e) => {
    setStartDate(e.target.value);
    setEndDate(""); // Reset end date whenever start date changes
  };

  const handleEndDateChange = (e) => {
    setEndDate(e.target.value);
  };

  const today = new Date().toISOString().split("T")[0]; // Get today's date in 'YYYY-MM-DD' format

  return (
    <div>
      <HRNavbar />
      <Box sx={{ flexGrow: 1, ml: 1, mr: 1, mt: 1 }}>
  <Box sx={{ display: 'flex', justifyContent: 'center' }}>
         <Stack
                            direction={isSmallScreen ? "column" : "row"}
                            spacing={1}
                            alignItems={isSmallScreen ? "center" : "flex-start"}
                            sx={{ pt: 1 }}
                          >
 
            <Typography
              sx={{
                fontSize: 16,
                fontWeight: 600,
                marginTop: "20px",
                marginLeft: "10px",
              }}
              color="text.secondary"
              gutterBottom
            >
              Hospital Report
            </Typography>
            <Box sx={{ mb: 1, width: 300, marginLeft: "1rem" }}>
              <TextField
                select
                label="Select Hospital Name"
                variant="outlined"
                size="small"
                sx={{
                  height: 39,
                  width: "100%",
                  backgroundColor: "white",
                  boxShadow: "4px 4px 10px 7px rgba(135, 135, 135, 0.05)",
                  borderRadius: "7px",
                }}
                InputProps={{ style: { border: "none" } }}
                inputProps={{ "aria-label": "Select Group" }}
                value={hospitalType}
                onChange={(e) => setHospitalType(e.target.value)}
                MenuProps={{
                  PaperProps: {
                    style: {
                      maxHeight: "100px",
                      overflowY: "auto",
                    },
                  },
                }}
                SelectProps={{
                  MenuProps: {
                    PaperProps: {
                      style: {
                        maxHeight: "200px", // Set the maximum height to 200px
                        maxWidth: "200px",
                      },
                    },
                    MenuListProps: {
                      style: {
                        maxHeight: "200px", // Set the maximum height to 200px
                      },
                    },
                  },
                }}
              >
                {hospitalData.map((item, index) => (
                  <MenuItem key={item.hosp_id} value={item.hosp_id}>
                    {item.hospital_name}
                  </MenuItem>
                ))}
              </TextField>
            </Box>
            <Box
              component="form"
              sx={{
                marginLeft: "2rem",
                p: "2px 4px",
                display: "flex",
                alignItems: "center",
                width: 300,
                height: "2.5rem",
                backgroundColor: "#ffffff",
                boxShadow: "4px 4px 10px 7px rgba(135, 135, 135, 0.05)",
                borderRadius: "10px",
                border: "1px solid #C9C9C9",
              }}
            >
              <InputBase
                sx={{ ml: 1, mr: 1, flex: 1 }}
                type="date"
                placeholder="Start Date | DD/MM/YYYY"
                inputProps={{ "aria-label": "select date" }}
                value={startDate}
                onChange={handleStartDateChange}
              />
            </Box>

            <Box
              component="form"
              sx={{
                marginLeft: "2rem",
                p: "2px 4px",
                display: "flex",
                alignItems: "center",
                width: 300,
                height: "2.5rem",
                backgroundColor: "#ffffff",
                boxShadow: "4px 4px 10px 7px rgba(135, 135, 135, 0.05)",
                borderRadius: "10px",
                border: "1px solid #C9C9C9",
              }}
            >
              <InputBase
                sx={{ ml: 1, mr: 1, flex: 1 }}
                type="date"
                placeholder="End Date | DD/MM/YYYY"
                inputProps={{
                  "aria-label": "select date",
                  min: startDate, // Set the minimum selectable date to the start date
                  // max: today, // Set the maximum selectable date to today
                }}
                value={endDate}
                onChange={handleEndDateChange}
                max={today}
              />
            </Box>

            <Button
              variant="contained"
              style={{
                backgroundColor: "#347B89",
                color: "white",
                textTransform: "capitalize",
              }}
              onClick={handleViewReport}
            >
              View Report
            </Button>

            <FileDownloadOutlinedIcon
              onClick={() => {
                handleDownloadExcel();
              }}
            />
          </Stack>
        </Box>

        <TableContainer sx={{ ml: 1, mr: 1 }}>
          <Table>
            <TableHead>
              <TableRow>
                <HospitalCard
                  style={{
                    background: "#D1C4E9",
                    color: "#000000ff",
                    borderRadius: "8px 10px 0 0",
                    height: "3rem",
                  }}
                >
                  <CardContent
                    style={{ flex: 3, borderRight: "1px solid #FFFFFF" }}
                  >
                    <Typography variant="subtitle2">Hospital Name</Typography>
                  </CardContent>
                  <CardContent
                    style={{ flex: 3, borderRight: "1px solid #FFFFFF" }}
                  >
                    <Typography variant="subtitle2">Patient Count</Typography>
                  </CardContent>
                </HospitalCard>
              </TableRow>
            </TableHead>

            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell
                    colSpan={7}
                    align="center"
                    style={{ height: "45vh" }}
                  >
                    <CircularProgress />
                  </TableCell>
                </TableRow>
              ) : hospDataTable.length === 0 ? (
                <TableRow>
                  <TableCell
                    colSpan={7}
                    align="center"
                    style={{ height: "45vh" }}
                  >
                    <Typography variant="subtitle1">No data found</Typography>
                  </TableCell>
                </TableRow>
              ) : (
                hospDataTable
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((hosp, index) => (
                    <TableRow key={index}>
                      <HospitalCard
                        style={{
                          height: "3rem",
                          background: "white",
                          color: "rgba(0, 0, 0, 0.87)",
                          fontWeight: "100",
                          borderRadius: "8px 10px 8px 8px",
                        }}
                      >
                        <CardContent
                          style={{ flex: 3, borderRight: "1px solid #FFFFFF" }}
                        >
                          <Typography variant="subtitle2">
                            {hosp.hospital_name || "-"}
                          </Typography>
                        </CardContent>
                        <CardContent
                          style={{ flex: 3, borderRight: "1px solid #FFFFFF" }}
                        >
                          <Typography variant="subtitle2">
                            {hosp.patient_count || "-"}
                          </Typography>
                        </CardContent>
                      </HospitalCard>
                    </TableRow>
                  ))
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination

         sx={{  overflowY: "hidden" }}
          rowsPerPageOptions={[5, 10, 25, 30, 50]}
          component="div"
          count={hospDataTable.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Box>
      <Footer />
    </div>
  );
};

export default HospitalReport;
